export default {
	shareCollection: {
		owner: {
			title: 'Compartilhe sua coleção',
			description:
				'Compartilhe a sua coleção com quem decide com você: Organizem, comparem e decidam, tudo em um único lugar.',
			shareMessage:
				'Oi! Montei uma coleção com meus imóveis favoritos do PilarHomes, assim você consegue acompanhar também.\n\nVem dar uma olhada comigo!\n\n{shareUrl}'
		},
		visitor: {
			title: 'Compartilhe a coleção',
			description:
				'Compartilhe a coleção de {ownerName} com quem decide com vocês: Organizem, comparem e decidam, tudo em um único lugar.',
			shareMessage:
				'Oi! {ownerName} montou uma coleção com seus imóveis favoritos do PilarHomes. Assim você consegue acompanhar também.\n\nVem dar uma olhada com a gente!\n\n{shareUrl}'
		},
		common: {
			footer:
				'É só compartilhar uma vez: O link mostra sempre a versão mais atual da coleção.'
		}
	}
};
